import { Core } from "@faire/design-tokens";
import { getSpacing, Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography/index";
import React from "react";
import styled from "styled-components";

import { ISingleVettingCriteriaInfo } from "@faire/retailer/features/Showroom/ShowroomVettingCriteria/ShowroomVettingCriteriaInfo";

export const SingleShowroomVettingCriteria: React.FC<
  ISingleVettingCriteriaInfo
> = ({
  icon,
  vettingValue,
  vettingValueDescription,
  color,
  titleTypographyVariants,
  alignText,
}) => {
  if (vettingValueDescription) {
    return (
      <Grid>
        <IconWrapper>{icon}</IconWrapper>
        <Title color={color} variant={titleTypographyVariants}>
          {vettingValue}
        </Title>
        <Description>{vettingValueDescription}</Description>
      </Grid>
    );
  }

  return (
    <>
      {icon}
      <Spacer size="1x" />
      <Title
        color={color}
        variant={titleTypographyVariants}
        $alignText={alignText}
      >
        {vettingValue}
      </Title>
    </>
  );
};

const Title = styled(Typography)<{
  $alignText?: string;
}>`
  grid-area: title;
  text-align: ${(props) => props.$alignText ?? "left"};
`;

const Description = styled(Typography).attrs({
  color: Core.text.subdued,
})`
  grid-area: description;
  text-align: left;
`;

const IconWrapper = styled.div`
  grid-area: icon;
  display: flex;
  justify-self: center;
`;

const Grid = styled.div`
  display: grid;
  align-items: center;
  justify-items: start;
  grid-template-columns: 32px auto;
  grid-template-rows: auto;
  grid-template-areas:
    "icon title"
    ".    description";
  grid-gap: ${getSpacing("1x")};
`;
